import {
  PAYMENTS_BATCH_DELETE_REQUEST,
  PAYMENTS_BATCH_DELETE_SUCCESS,
  PAYMENTS_BATCH_DELETE_FAILURE,
  PAYMENTS_FETCH_MANY_REQUEST,
  PAYMENTS_FETCH_MANY_SUCCESS,
  PAYMENTS_FETCH_MANY_FAILURE,
  PAYMENTS_FETCH_REQUEST,
  PAYMENTS_FETCH_SUCCESS,
  PAYMENTS_FETCH_FAILURE,
  PAYMENTS_SAVE_REQUEST,
  PAYMENTS_SAVE_SUCCESS,
  PAYMENTS_SAVE_FAILURE,

  EMPTY_PAYMENTS,
  CLEAR_ERRORS
} from './types'

export default {
  deleteMany ({ commit }, { ids = [] }) {
    commit(PAYMENTS_BATCH_DELETE_REQUEST)
    return window.axios.post('/payments', { _method: 'DELETE', ids }).then(response => {
      commit(PAYMENTS_BATCH_DELETE_SUCCESS, response)
      return response
    }).catch(error => {
      commit(PAYMENTS_BATCH_DELETE_FAILURE, error)
      throw error
    })
  },
  fetchMany ({ commit }, { query = '', page = 1, extraParams = {} }) {
    commit(PAYMENTS_FETCH_MANY_REQUEST)
    return window.axios.get('/payments', { params: { query, page, ...extraParams } }).then(response => {
      commit(PAYMENTS_FETCH_MANY_SUCCESS, response)
      return response
    }).catch(error => {
      commit(PAYMENTS_FETCH_MANY_FAILURE, error)
      throw error
    })
  },
  fetch ({ commit }, id) {
    commit(PAYMENTS_FETCH_REQUEST)
    return window.axios.get(`/payments/${id}`).then(response => {
      commit(PAYMENTS_FETCH_SUCCESS, response)
      return response
    }).catch(error => {
      commit(PAYMENTS_FETCH_FAILURE, error)
      throw error
    })
  },
  save ({ commit }, user) {
    const path = user.id ? `/payments/${user.id}` : '/payments'
    const method = user.id ? 'put' : 'post'

    commit(PAYMENTS_SAVE_REQUEST)
    return window.axios[method](path, user).then(response => {
      commit(PAYMENTS_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(PAYMENTS_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(PAYMENTS_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  saveRefund ({ commit }, { payment_id, refund }) {
    commit(PAYMENTS_SAVE_REQUEST)
    return window.axios.post(`/payments/refund/${payment_id}`, refund).then(response => {
      commit(PAYMENTS_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(PAYMENTS_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(PAYMENTS_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  empty({ commit }) {
    commit(EMPTY_PAYMENTS);
  },
  clearErrors({ commit }) {
    commit(CLEAR_ERRORS)
  },
  fetchManyUnpaid({ commit }, { query = "", page = 1, extraParams = {} }) {
        commit(PAYMENTS_FETCH_MANY_REQUEST);
        return window.axios
            .get("/payments/unpaid", { params: { query, page, ...extraParams } })
            .then(response => {
                commit(PAYMENTS_FETCH_MANY_SUCCESS, response);
                return response;
            })
            .catch(error => {
                commit(PAYMENTS_FETCH_MANY_FAILURE, error);
                throw error;
            });
    }
}
